// WelcomeHeader.jsx

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './WelcomeHeader.module.scss';
import fav from 'assets/img/fav.png';
import AuthModal from 'components/AuthModal/AuthModal';
import ProfileButton from 'components/ProfileButton/ProfileButton';
import { useTheme } from 'contexts/ThemeContext';

const WelcomeHeader = () => {
  const navigate = useNavigate();
  const { theme } = useTheme();
  const [authOpen, setAuthOpen] = useState(false);
  const [authMode, setAuthMode] = useState('login');

  useEffect(() => {
    const handler = () => setAuthOpen(true);
    window.addEventListener('openAuth', handler);
    return () => window.removeEventListener('openAuth', handler);
  }, []);

  return (
    <div className={styles.wrapper}>
      {/* LOGO */}
      <div className={styles.logo__wrapper} onClick={() => navigate('/')} role="button" tabIndex={0}>
        <img src={fav} className={styles.logo} alt="NCORE Logo" />
        <div className={styles.logoTextWrapper}>
          <svg width="140" height="40" viewBox="0 0 140 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <text x="0" y="32" fill="#FF8C00" fontFamily="'Orbitron', sans-serif" fontWeight="800" fontSize="32" letterSpacing="2">N</text>
            <text x="30" y="32" fill={theme === 'light' ? '#000000' : 'white'} fontFamily="'Orbitron', sans-serif" fontWeight="800" fontSize="32" letterSpacing="2">CORE</text>
          </svg>
      </div>
        <div className={styles.betaBadge}>
          <span>BETA</span>
        </div>
        <div
          className={styles.favoritesBadge}
          onClick={(e) => { e.stopPropagation(); navigate('/favorites'); }}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => e.key === 'Enter' && navigate('/favorites')}
        >
          <span>★ Наши любимчики</span>
        </div>
      </div>

      {/* LOGIN / PROFILE */}
      <div className={styles.enter_buttons}>
        <ProfileButton 
          onLoginClick={() => { setAuthMode('login'); setAuthOpen(true); }} 
          onRegisterClick={() => { setAuthMode('register'); setAuthOpen(true); }}
          onOpenProfile={() => navigate('/profile')} 
        />
      </div>

      <AuthModal open={authOpen} onClose={() => setAuthOpen(false)} initialMode={authMode} />
    </div>
  );
};

export default WelcomeHeader;
